import { signal } from "@preact/signals";
import type { SessionType } from "../engine/session";

/** Which session type is currently running in the Booth, if any — purely
    ephemeral UI state, not part of Profile. */
export const activeSession = signal<SessionType | null>(null);

export function startSession(type: SessionType): void {
  activeSession.value = type;
}

export function endSession(): void {
  activeSession.value = null;
}
